import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import React from 'react';
import classnames from 'classnames';
import ImageThumbnail from 'components/util/imageThumbnail';
import styles from './styles.scss';

export default function MaterialSelect(props) {
  const hasThumbnails =
    props.options.length &&
    !!props.options.some(opt => {
      return opt.thumbnail;
    });
  let sampleIcon;
  const hasIcons =
    props.options.length &&
    !!props.options.some(opt => {
      if (opt.icon) sampleIcon = opt.icon;
      return opt.icon;
    });
  const hasStyles =
    props.options.length &&
    !!props.options.some(opt => {
      return opt.style;
    });
  const isReduxForm = !!props.input;
  const onChange = isReduxForm ? props.input.onChange : props.onChange;

  let settings = {
    floatingLabelText: props.floatingLabelText,
    floatingLabelFixed: props.floatingLabelFixed,
    hintText: props.hintText,
    errorText: props.errorText,
    disabled: props.disabled,
    className: _generateClassName(props, styles.selectControl),
    autoWidth: props.autoWidth,
    multiple: props.multiple,
    style: props.style || {}
  };

  if (hasThumbnails) {
    settings.selectionRenderer = value => _thumbnailValueRenderer(value, props);
  } else if (hasStyles) {
    settings.selectionRenderer = value => _styleValueRenderer(value, props);
  } else if (hasIcons) {
    settings.selectionRenderer = value => _iconValueRenderer(value, props);
    if (props.hideValueLabel) {
      settings.className += ` ${styles.iconWidth}`;
    }
  } else {
    settings.selectionRenderer = value => _valueRenderer(value, props);
  }

  if (isReduxForm) {
    settings = { ...settings, ...props.input };
    settings.onChange = (event, index, value) =>
      onChange(_renderValue(value, settings.multiple, props.options));
    settings.onBlur = () => props.input.onBlur(props.input.value);
    settings.value = props.input.value;
    settings.errorText = props.meta.touched ? props.meta.error : '';
  } else {
    settings.onChange = (event, index, value) =>
      onChange(_renderValue(value, settings.multiple, props.options));
    settings.onBlur = props.onBlur;
    settings.value = props.value;
  }

  return (
    <SelectField {...settings}>
      {props.options.map(opt => {
        let itemSettings = {
          key: opt.value,
          value: opt.value,
          checked: _isChecked(settings, opt.value),
          insetChildren: settings.multiple,
          style: opt.style || {}
        };
        if (hasThumbnails) {
          return (
            <MenuItem {...itemSettings}>
              <div className={styles.psuedoLeftimg}>
                {opt.thumbnail ? (
                  <ImageThumbnail imgUrl={opt.thumbnail} />
                ) : (
                  <span className={styles.invisible}>
                    <div className={styles.thumbnailImg} />
                  </span>
                )}
              </div>{' '}
              {opt.label}
            </MenuItem>
          );
        }
        if (hasIcons) {
          return (
            <MenuItem {...itemSettings}>
              <div className={classnames(styles.leftIconWrapper)}>
                {opt.icon || (
                  <span className={styles.invisible}>{sampleIcon}</span>
                )}
              </div>{' '}
              {opt.label}
            </MenuItem>
          );
        }
        itemSettings.primaryText = opt.label;
        return <MenuItem {...itemSettings} />;
      })}
    </SelectField>
  );
}

const _generateClassName = (
  { className = '', floatingLabelText, disabled },
  inputClass = styles.inputControl
) => {
  let concatted = inputClass + (className ? ` ${className}` : '');
  if (floatingLabelText) concatted += ` ${styles.hasFloatingText}`;
  if (disabled) concatted += ` ${styles.disabled}`;
  return concatted;
};

const _isChecked = (settings, optionValue) => {
  const checked =
    settings.multiple &&
    settings.value &&
    settings.value.find(val => {
      return val === optionValue;
    });

  return !!checked;
};

const _renderValue = (value, multiple, options) => {
  if (multiple && value.includes(-1)) {
    // last in array means it was last clicked
    if (value.indexOf(-1) !== value.length - 1) {
      return value.filter(val => {
        return val !== -1;
      });
    } else {
      return [-1];
    }
  } else if (options.find(o => o.value === -1) && value.length === 0) {
    return [-1];
  } else {
    return value;
  }
};

function _valueRenderer(value, props) {
  if (Array.isArray(value) && value.length > 1) {
    return _value(value, props);
  } else {
    let selection = props.options.find(opt => {
      if (Array.isArray(value)) {
        return opt.value === value[0];
      }
      return opt.value === value;
    });
    selection = selection || {};
    return _value(value, props, selection);
  }
}

function _thumbnailValueRenderer(value, props) {
  if (Array.isArray(value) && value.length > 1) {
    return _value(value, props);
  }
  let selection = props.options.find(opt => {
    if (Array.isArray(value)) {
      return opt.value === value[0];
    }
    return opt.value === value;
  });
  selection = selection || {};
  return (
    <div>
      {!!selection.thumbnail && (
        <div className={styles.valueThumbnail}>
          <ImageThumbnail imgUrl={selection.thumbnail} />
        </div>
      )}
      {_value(value, props, selection)}
    </div>
  );
}

function _iconValueRenderer(value, props) {
  if (Array.isArray(value) && value.length > 1) {
    return _value(value, props);
  }
  const selection = props.options.find(opt => {
    if (Array.isArray(value)) {
      return opt.value === value[0];
    }
    return opt.value === value;
  });
  return (
    <div>
      {!!selection.icon && (
        <div className={styles.valueIcon}>{selection.icon}</div>
      )}
      {_value(value, props, selection)}
    </div>
  );
}

function _styleValueRenderer(value, props) {
  const selection = props.options.find(opt => {
    return opt.value === value;
  });
  let style = selection.style ? Object.assign({}, selection.style) : {};
  if (style.backgroundColor) {
    style.padding = '3px';
    style.borderRadius = '4px';
  }
  return (
    <span
      style={style}
      className={classnames({
        [styles.textTertiary]: props.colorValue && value
      })}>
      {selection.label}
    </span>
  );
}

function _value(value, props, selection) {
  if (Array.isArray(value) && value.length > 1) {
    return <span>{value.length} selected</span>;
  } else {
    return <span>{!props.hideValueLabel && selection.label}</span>;
  }
}



// WEBPACK FOOTER //
// ./src/components/util/materialSelect/index.js